export default __webpack_public_path__ + "static/media/product_card.84417a12.svg";